import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7979ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cmpLayer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hideMobile" }, "Manage Settings : Purposes and Features", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "hideDesktop",
  style: {"font-size":"16px"}
}, "Purposes and Features", -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"listItemHeader\" data-v-0f7979ed><div class=\"descriptionLabel\" data-v-0f7979ed>Description</div><div style=\"flex-grow:1;\" data-v-0f7979ed></div><div class=\"descriptionLabel\" style=\"margin-left:8px;\" data-v-0f7979ed>Consent</div><div class=\"vendorControlLabel\" style=\"width:30px;margin-left:8px;\" data-v-0f7979ed> </div></div>", 1)
const _hoisted_5 = { class: "scrollingContainer" }
const _hoisted_6 = { class: "cmpButtonContainer" }
const _hoisted_7 = {
  key: 0,
  class: "cmpButtonLink manageLinkDisabled"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"-14px"} }, "Accept All and Exit", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "cmpSVGButtonArrow",
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "__cmpIcon",
    d: "M479.3 250L246.5 482.7l-67.1-67L345 250 179.4 84.4l67.1-67.1L479.3 250z"
  })
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VendorListDivider = _resolveComponent("VendorListDivider")!
  const _component_PurposeItem = _resolveComponent("PurposeItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, [
      _createTextVNode("The purposes for which we or our partners use your data are listed below. Some partners do not ask for your consent to process your data. Instead, they rely on their legitimate business interest. Use the toggle buttons to consent to purposes and features requiring consent or object to purposes based on legitimate interests. You may also review the "),
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.partnersClick && _ctx.partnersClick(...args)), ["prevent"]))
      }, "list of partners"),
      _createTextVNode(" for more information. If you do not consent or if you later withdraw your consent, you will still see advertising while visiting this site, but it will not be personalized for you.")
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_component_VendorListDivider, {
        key: 10000,
        label: "Purposes"
      })),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purposes, (purpose) => {
        return (_openBlock(), _createBlock(_component_PurposeItem, {
          itemType: "purpose",
          purpose: purpose,
          key: purpose.id+1000,
          onModelChangeEvent: _ctx.handleModelChangeEvent
        }, null, 8, ["purpose", "onModelChangeEvent"]))
      }), 128)),
      (_openBlock(), _createBlock(_component_VendorListDivider, {
        key: 10001,
        label: "Special Purposes"
      })),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialPurposes, (purpose) => {
        return (_openBlock(), _createBlock(_component_PurposeItem, {
          itemType: "specialPurpose",
          purpose: purpose,
          key: purpose.id+2000,
          onModelChangeEvent: _ctx.handleModelChangeEvent
        }, null, 8, ["purpose", "onModelChangeEvent"]))
      }), 128)),
      (_openBlock(), _createBlock(_component_VendorListDivider, {
        key: 10002,
        label: "Features"
      })),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
        return (_openBlock(), _createBlock(_component_PurposeItem, {
          itemType: "feature",
          purpose: feature,
          key: feature.id + 3000,
          onModelChangeEvent: _ctx.handleModelChangeEvent
        }, null, 8, ["purpose", "onModelChangeEvent"]))
      }), 128)),
      (_openBlock(), _createBlock(_component_VendorListDivider, {
        key: 10003,
        label: "Special Features"
      })),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialFeatures, (feature) => {
        return (_openBlock(), _createBlock(_component_PurposeItem, {
          itemType: "specialFeature",
          purpose: feature,
          key: feature.id + 4000,
          onModelChangeEvent: _ctx.handleModelChangeEvent
        }, null, 8, ["purpose", "onModelChangeEvent"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.dirty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Save and Exit"))
        : _createCommentVNode("", true),
      (_ctx.dirty)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "cmpButtonLink manageLink",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveAndExitClick && _ctx.saveAndExitClick(...args)))
          }, "Save and Exit"))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        class: "cmpButtonLink rejectLink",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rejectAllClick && _ctx.rejectAllClick(...args)))
      }, "Reject All and Exit"),
      _createElementVNode("a", {
        class: "cmpButtonLink acceptLink",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.acceptAllClick && _ctx.acceptAllClick(...args))),
        style: {"position":"relative"}
      }, _hoisted_10)
    ])
  ]))
}